import Songs from '../components/pages/Songs/Songs.vue'
const routes = [
  {
    path: '/songs',     //音乐管理首页
    name: 'songs',
    component: Songs
  },
]

export default routes